module.exports = __webpack_public_path__ + "static/media/home.185c72c2.svg";